import { render, staticRenderFns } from "./SwappingSquaresSpinner.vue?vue&type=template&id=4ac83234&scoped=true"
import script from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js"
export * from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js"
import style0 from "./SwappingSquaresSpinner.vue?vue&type=style&index=0&id=4ac83234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac83234",
  null
  
)

export default component.exports